import React, { useState, useEffect } from "react";
import { Chart } from "react-google-charts";
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { LOADING } from '../../action'
import { useSelector, useDispatch } from 'react-redux';


export function HelpChart() {
 
  const [chartData, setChartData] = useState([]);
  const options = {
    allowHtml: true,
    nodeClass: "my-node-class",
    selectedNodeClass: 'menu Access'
  };
  const dispatch = useDispatch();
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    dispatch({ type: LOADING, payload: true });
    await getchart();
    dispatch({ type: LOADING, payload: false });
  }
  const getchart = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + "User/UserTypeDetails";
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          console.log(res.data);
          let data = [];
          let userTypes = [];
          data.push([{ "v": "Access Role", "f": "AccessRole" }, "", ""]);
          res.data.forEach((dt) => {
            debugger
            if (userTypes.indexOf(dt.usertype) == -1)
              userTypes.push(dt.usertype);
          });
          userTypes.forEach((uut) => {
            debugger
            if (uut) {
              const styledUut = `<div style="pointer:cursor;
                  text-align: center;
                   vertical-align: middle;
                     font-family: Bai Jamjuree !important;
                  cursor: default;
                 -moz-border-radius: 5px;
                   -webkit-border-radius: 5px;
                      -webkit-box-shadow: rgb(0 0 0 / 50%) 3px 3px 3px;
                  -moz-box-shadow: rgba(0, 0, 0, 0.5) 3px 3px 3px;
                  background-color:#ff4717;
                     border-radius: 10px;
                      color:white;
                         font-size: 14px;
                       font-weight: 700;
                       height: 55px;
                       padding-top: 15px;
                       width:150px;
                       margin-top:-5px;
                       ">${uut}</div>`;
              data.push([{ "v": `${uut}`, "f": styledUut }, `<div class="Access">Access Role</div>`, ""]);
            }
            let menus = `<ul>`;
            res.data.forEach((dt) => {
              if (dt.usertype == uut) {
                menus += `<li style="list-style-type: none;font-size: 14px !important;line-height: 20px !important;color:#1a1a31;font-weight: 700">${dt.screenname}</li>`
              }
            });
            menus += "</ul>";
            const styledmenu = `<div class ="menu">${menus}</div>`
            data.push([{ "v": `menu${uut}`, 'f': styledmenu }, `${uut}`, ""]);
            data.map((item) => {
              console.log(item);
            })
          });
          // let data=[];
          // let userTypes=[];
          // data.push([{"v":"Access Role","f":"Access Role"},"",""]);
          // res.data.forEach((dt)=>{
          //   if(userTypes.indexOf(dt.usertype)==-1)
          //   userTypes.push(dt.usertype);
          // });
          // userTypes.forEach((uut)=>{
          //   data.push([{"v":`${uut}`,"f":`${uut}`},"Access Role",""]);
          //   let menus=`<ul style="list-style-type: none;">`;
          //   res.data.forEach((dt)=>{
          //     if(dt.usertype==uut)
          //     {
          //    menus+=`<li style="list-style-type: none;font-size: 12px !important;line-height: 20px !important;color: #1A1A31;">${dt.screenname}</li>`
          //     }
          //   });
          //   menus+="</ul>";
          //   data.push([{ "v":`menu${uut}`,'f':`${menus}`},`${uut}`,""]);
          // });
          setChartData(data);
        }
        else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        // ToastError(error.response.data.message);
        // dispatch({ type: LOADING, payload: false });
      });
  }
  return (
    <div>
      {chartData.length && <Chart
        chartType="OrgChart"
        data={chartData}
        options={options}
      // width="100%"
      // height="400px"
      // className={classes.btnStyle1}
      />}
      <style>{`
        .my-node-class{
          pointer:cursor;
          text-align: center;
          vertical-align: middle;
         font-family: Bai Jamjuree !important;
         -moz-border-radius: 5px;
         -webkit-border-radius: 5px;
      }
         .menu{
          style=" pointer:cursor;
          text-align: center;
          vertical-align: middle;
          font-family: Bai Jamjuree !important;
          box-shadow: rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px;
          background-color: rgb(255, 255, 255);
          border-radius: 10px;
          height:450px;
          margin-top: -5px;
         }
                 .Access{
      pointer:cursor;
      text-align: center;
    vertical-align: middle;
    font-family: Bai Jamjuree !important;
    border-radius: 25px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    -webkit-box-shadow: rgb(0 0 0 / 50%) 3px 3px 3px;
    -moz-box-shadow: rgba(0, 0, 0, 0.5) 3px 3px 3px;
    background-color: #1A1A31;
    color:white;
    font-size: 16px;
    font-weight:700;
    height:50px;
    padding-top: 12px;
    margin-top: 10px;
     }
   .google-visualization-orgchart-lineleft{
    border-left: 1px solid rgb(26, 26, 49);
   }
   .google-visualization-orgchart-linebottom  {
   border-bottom: 1px solid rgb(26, 26, 49);
   }
   .google-visualization-orgchart-lineright {
    border-right: 1px solid rgb(26, 26, 49);
}
       `}</style>
    </div>
  );

}